import { useContext } from "react";
import { useLocation } from "react-router-dom";
import AroundCircle from "src/components/AroundCircle/AroundCircle";
import Page from "src/components/Report/Page";
import jobContext from "src/context/jobContext";

export default function Page6() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    const { job } = useContext(jobContext)
    let shayestegihayeTakhasosi;
    if (JSON.parse(localStorage?.data)?.[jobId]?.shayestegihayeTakhasosi) {
        shayestegihayeTakhasosi = JSON.parse(localStorage?.data)?.[jobId]?.shayestegihayeTakhasosi
    } else {
        shayestegihayeTakhasosi = []
    }



    let div = Object.keys(shayestegihayeTakhasosi).map(function (key, index) {        
        return (
            <>
                <div className="border borde-solid border-gray-300 p-2 rounded-sm text-xs font-semibold">{shayestegihayeTakhasosi[`shayestegihayeTakhasosi${index.toString() + 1}`]}</div>
                <div className="border borde-solid border-gray-300 p-2 rounded-sm text-xs font-semibold">{shayestegihayeTakhasosi[`shayestegihayeTakhasosi${index.toString() + 2}`]}</div>
                <div className="border borde-solid border-gray-300 p-2 rounded-sm text-xs font-semibold">{shayestegihayeTakhasosi[`shayestegihayeTakhasosi${index.toString() + 3}`]}</div>
                <div className="border borde-solid border-gray-300 p-2 rounded-sm text-xs font-semibold">{shayestegihayeTakhasosi[`shayestegihayeTakhasosi${index.toString() + 4}`]}</div>
                <div className="border borde-solid border-gray-300 p-2 rounded-sm text-xs font-semibold">{shayestegihayeTakhasosi[`shayestegihayeTakhasosi${index.toString() + 5}`]}</div>
            </>
        )
    })

    let dataArray = []
    let first, second;
    Object.keys(shayestegihayeTakhasosi).map((key, index) => {
        first = key.substring(23, 24);
        second = key.substring(24, 25);
        // console.log(key, first);
        if (second == "1") {
            dataArray.push(shayestegihayeTakhasosi[key]);
        }
    })
    return (
        <Page pageNumber={15}>
            <div className="font-bold text-lg">
                مدل شایستگی تخصصی {job.title}
            </div>
            <div className="flex flex-col ml-20 my-10">
                <AroundCircle title={`شایستگی تخصصی ${job.title}`} dataArray={dataArray} />
            </div>
            <div className="flex flex-col justify-between mt-32">
                <div className="bg-blue-600 grid grid-cols-5 w-full justify-between text-white p-3 py-2 rounded-sm">
                    <div className="text-center">عنوان شایستگی</div>
                    <div className="text-center">شرح شایستگی</div>
                    <div className="text-center">مولفه‌های شایستگی</div>
                    <div className="text-center">برنامه توسعه</div>
                    <div className="text-center">آزمون/ابزار</div>

                </div>
                <div className="grid grid-cols-5 gap-0 w-full rounded-md">

                    {div}
                </div>
            </div>
        </Page>
    )
}